import { render, staticRenderFns } from "./BrainWordCloud.vue?vue&type=template&id=1aac3d08&scoped=true"
import script from "./BrainWordCloud.vue?vue&type=script&lang=js"
export * from "./BrainWordCloud.vue?vue&type=script&lang=js"
import style0 from "./BrainWordCloud.vue?vue&type=style&index=0&id=1aac3d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac3d08",
  null
  
)

export default component.exports